// extracted by mini-css-extract-plugin
module.exports = {"root":"cmp-Minicart__minicart__root","root_open":"cmp-Minicart__minicart__root_open cmp-Minicart__minicart__root"};